<template>
    <div>
        <TabsModais v-if="arrayValid == true && show == true" ref="tabs" :tabs="tabsPorEtapas"
                    :contentId="idOcorrencia" :content-props="{ idOcorrencia: idOcorrencia, idModulo: idModulo, idProcesso: idProcesso }"
                    @liberaAvancarEtapa="liberaAvancarEtapa" @reloadGridOcorrencias="reloadGridOcorrencias"
                    @liberaUltimaEtapa="liberaUltimaEtapa" :reloadContent="reload"
                    @handleButtonProcessoTab="handleButtonProcessoTab" @tab-clicked="handleTabClick"
                    @setFlNovoProcesso="setFlNovoProcesso" :idOcorrencia="idOcorrencia" @setActionCard="setActionCard"
                    :idModulo="idModulo" :ocorrenciaTabSelect="ocorrenciaTabSelect" />
    </div>
</template>

<script>

    import TabsModais from "@/components/App/TabsModais.vue";
    import axios from 'axios';

    export default {
        name: "Ticket",
        emits: [
            'reloadGridOcorrencias',
            'liberaUltimaEtapa',
            'liberaAvancarEtapa',
            'tab-clicked',
            'handleButtonProcessoTabTickets',
            'setNovoProcessoTickets',
            'setActionCard'

        ],
        components: {
            TabsModais,
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0,
            },
            idProcesso: {
                type: Number,
                default: 0
            },
            cdSetor: {
                type: Number,
                default: 0
            },
            cdSetorClassificacao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0,
            },
            ocorrenciaTabSelect: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                dafault: false
            }
        },
        data() {
            return {
                tabs: [
                    {
                        id: 1,
                        title: "Dados do Ticket",
                        icon: "fa fa-newspaper",
                        class: "nav-link",
                        class_content: "tab-pane fade show active",
                        target: "dados",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Dados",
                        cdOcorrenciaTab: 1
                    },
                    {
                        id: 13,
                        title: "Dados do Chamado",
                        icon: "fa fa-newspaper",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "dados_chamado",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Dados_Chamado",
                        cdOcorrenciaTab: 12
                    },
                    {
                        id: 2,
                        title: "Tarefas Executar",
                        icon: "far fa-check-square",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "tarefas",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Tarefas_Executar",
                        cdOcorrenciaTab: 2

                    },
                    {
                        id: 3,
                        title: "Agendamentos",
                        icon: "far fa-calendar-alt",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "agendamentos",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Agendamento",
                        cdOcorrenciaTab: 3

                    },
                    {
                        id: 17,
                        title: "Solicitações Contato",
                        icon: "fas fa-stream",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "solicitacaocontato",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "SolicitacaoContato",
                        cdOcorrenciaTab: 16

                    },
                    {
                        id: 11,
                        title: "Senhas",
                        icon: "fas fa-address-card",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "cortesia",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Cortesia",
                        cdOcorrenciaTab: 10

                    },
                    {
                        id: 12,
                        title: "Vídeo Chamadas",
                        icon: "fas fa-video",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "videochamada",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Videochamada",
                        cdOcorrenciaTab: 11

                    },
                    {
                        id: 4,
                        title: "Usuários",
                        icon: "fas fa-users",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "usuarios",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Usuarios",
                        cdOcorrenciaTab: 4

                    },
                    {
                        id: 21,
                        title: "Usabilidade",
                        icon: "fas fa-balance-scale-right",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "usabilidade",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Usabilidade",
                        cdOcorrenciaTab: 19

                    },
                    {
                        id: 6,
                        title: "Contatos",
                        icon: "far fa-phone",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "contatos",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Contato",
                        cdOcorrenciaTab: 5

                    },
                    {
                        id: 22,
                        title: "WhatsApp",
                        icon: "fab fa-whatsapp",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "whatsapp",
                        path: "@/views/Tickets/Ticket_Crud/Tabs/",
                        componentName: "Whatsapp",
                        cdOcorrenciaTab: 20
                    },
                    {
                        id: 7,
                        title: "Anotações",
                        icon: "far fa-edit",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "anotacoes",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Anotacoes",
                        cdOcorrenciaTab: 6

                    },
                    {
                        id: 8,
                        title: "E-mails",
                        icon: "far fa-envelope",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "email",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Email",
                        cdOcorrenciaTab: 7

                    },
                    {
                        id: 9,
                        title: "Propostas",
                        icon: "fas fa-money-bill-alt",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "propostas",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Proposta",
                        cdOcorrenciaTab: 8
                    },
                    {
                        id: 19,
                        title: "Propostas",
                        icon: "fas fa-money-bill-alt",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "propostas",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "PropostaEventos",
                        cdOcorrenciaTab: 19
                    },
                    {
                        id: 10,
                        title: "Processos",
                        icon: "far fa-file-alt",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "processo",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Processo",
                        cdOcorrenciaTab: 9

                    },
                    {
                        id: 14,
                        title: "Mensagens do Chamado",
                        icon: "far fa-comments",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "mensagens_chamado",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Mensagens_Chamado",
                        cdOcorrenciaTab: 13

                    },
                    {
                        id: 15,
                        title: "Anexos do Chamado",
                        icon: "fas fa-paperclip",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "anexos_chamado",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Anexos_Chamado",
                        cdOcorrenciaTab: 14

                    },
                    {
                        id: 16,
                        title: "Status do Chamado",
                        icon: "fas fa-stream",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "status_chamado",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Status_Chamado",
                        cdOcorrenciaTab: 15

                    },
                    {
                        id: 18,
                        title: "Inscrição",
                        icon: "far fa-address-card",
                        class: "nav-link",
                        class_content: "tab-pane fade",
                        target: "inscricao",
                        path: "@/views/Modais/Ocorrencia/Tabs/",
                        componentName: "Inscricao",
                        cdOcorrenciaTab: 17
                    },
                ],
                currentTabComponent: "Dados",
                reload: false,
                tabsPorOcorrencia: [],
                tabsPorEtapas: [],
                arrayValid: false
            };
        },
        methods: {
            getSetorClassificado() {
                if (this.cdSetor > 0 || this.cdSetorClassificacao > 0) {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaTab/GetTabsOcorrencia?cdSetor=' + this.cdSetor + '&cdSetorClassificacao=' + this.cdSetorClassificacao + '&idModulo=' + this.idModulo, {
                        headers: this.$api.getTokenComercial(),
                        params: '',
                        notLoading: true
                    }).then(response => {
                        this.tabsPorOcorrencia = response.data.data;
                        this.mergeArrayTabs();
                    })
                }
            },
            mergeArrayTabs() {
                this.tabsPorEtapas = [];
                this.tabsPorEtapas = this.tabs.filter(tab => {
                    return this.tabsPorOcorrencia.rows.some(dado => dado.idOcorrenciaTab === tab.id);
                });
                this.arrayValid = true;

            },
            handleTabClick(tabId) {
                this.$emit('tab-clicked', tabId);
            },
            reloadGridOcorrencias() {
                this.$emit("reloadGridOcorrencias");
            },
            liberaAvancarEtapa(val) {
                this.$emit("liberaAvancarEtapa", val);
            },
            postAvancarEtapa() {
                this.$refs.tabs.$refs.Tarefas_Executar.postAvancarEtapa();
            },
            liberaUltimaEtapa(val) {
                this.$emit("liberaUltimaEtapa", val);
            },
            reloadGridsTarefaExecutar() {
                this.$refs.tabs.$refs.Tarefas_Executar.reloadGrids();
            },
            submitEmitirProcesso() {
                this.$refs.tabs.$refs.Processo.submitForm();
            },
            reloadContent() {
                this.reload = !this.reload
            },

            setFlNovoProcesso(val) {
                this.$emit("setNovoProcessoTickets", val)

            },
            handleButtonProcessoTab(val) {
                this.$emit("handleButtonProcessoTabTickets", val)
            },

            setActionCard(action) {
                this.$emit('setActionCard', action);
            },

        },
        mounted() {
            this.getSetorClassificado();
            this.$emit("liberaAvancarEtapa", false);
        },

        watch: {
            cdSetor(n, o) {
                this.getSetorClassificado();
            },
            cdSetorClassificacao(n, o) {
                this.getSetorClassificado();
            },
            idOcorrencia(n, o) {
                this.getSetorClassificado();
            },
            idModulo(n, o) { },
        }

    };
</script>

<style scoped lang="scss"></style>